/**
 * EcoFox Product Page Interactions
 */
(function() {
  function initCollapsibleRows() {
    const accordions = document.querySelectorAll('.product__accordion details');
    
    accordions.forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      if (!summary || !content) return;
      
      // Prevent standard instantly popping click behaviour
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (details.hasAttribute('open')) {
          // Slide up (close) animation
          const startHeight = content.offsetHeight;
          details.style.height = `${summary.offsetHeight + startHeight}px`;
          
          // Force layout reflow
          details.offsetHeight;
          
          details.style.transition = 'height 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)';
          details.style.height = `${summary.offsetHeight}px`;
          details.style.overflow = 'hidden';
          
          setTimeout(() => {
            details.removeAttribute('open');
            details.style.height = '';
            details.style.transition = '';
            details.style.overflow = '';
          }, 300);
        } else {
          // Slide down (open) animation
          details.setAttribute('open', '');
          const endHeight = content.offsetHeight;
          details.style.height = `${summary.offsetHeight}px`;
          details.style.overflow = 'hidden';
          
          // Force layout reflow
          details.offsetHeight;
          
          details.style.transition = 'height 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)';
          details.style.height = `${summary.offsetHeight + endHeight}px`;
          
          setTimeout(() => {
            details.style.height = '';
            details.style.transition = '';
            details.style.overflow = '';
          }, 300);
        }
      });
    });
  }

  function initSliderDots() {
    document.querySelectorAll('slider-component').forEach(slider => {
      const dotsContainer = slider.querySelector('.slider-dots-container');
      if (!dotsContainer) return;
      
      slider.addEventListener('slideChanged', (event) => {
        const currentPage = event.detail.currentPage;
        const visibleDots = Array.from(dotsContainer.querySelectorAll('.slider-dot')).filter(el => el.style.display !== 'none');
        visibleDots.forEach((dot, index) => {
          if (index + 1 === currentPage) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      });
      
      dotsContainer.addEventListener('click', (event) => {
        const dot = event.target.closest('.slider-dot');
        if (!dot) return;
        const visibleDots = Array.from(dotsContainer.querySelectorAll('.slider-dot')).filter(el => el.style.display !== 'none');
        const clickedIndex = visibleDots.indexOf(dot);
        if (clickedIndex === -1) return;
        const sliderItemsToShow = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((element) => element.clientWidth > 0);
        const targetSlide = sliderItemsToShow[clickedIndex];
        if (targetSlide && typeof slider.setSlidePosition === 'function') {
          slider.setSlidePosition(targetSlide.offsetLeft);
        }
      });
    });
  }

  function initAll() {
    initCollapsibleRows();
    initSliderDots();
  }

  // Bind on DOM ready and Shopify section loaded events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail.sectionId.includes('main')) {
      initAll();
    }
  });
})();
